module.exports = __webpack_public_path__ + "img/SKMJ_process.c4759f22.png";